import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';

import {ChatStoreModule} from "../store/store.module";

import {ChatListComponent} from "./chat-list.component";

import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";


@NgModule({
    imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatTooltipModule,
    MatRippleModule,
    ChatStoreModule,
    MatProgressSpinnerModule,
    ChatListComponent
],
    providers: [],
    exports: [
        ChatListComponent
    ]
})
export class ChatListModule
{
}
